export function isEmpty(
  element: string | number | undefined | null | unknown[]
): element is null | undefined | '' | [] {
  if (Array.isArray(element)) {
    return !element.length
  }

  if (element === null || element === undefined) {
    return true
  }

  if (typeof element === 'number') {
    return isNaN(element)
  }

  if (typeof element.length === 'number') {
    return !element.length
  }

  return false
}
